import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import MechanicsCalendar from "../components/MechanicsCalendar/MechanicsCalendar";
import getApiBase from "../components/getApiBase";

export default function CalendarPage() {
  const [shopId, setShopId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isOwner, setIsOwner] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadPrimaryShop() {
      try {
        const res = await fetch(`${getApiBase()}/api/mechanicDashboard/shops`, {
          credentials: "include",
        });
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.error || data.message || "Failed to load shop");
        }
        const shops = data.shops || [];
        const primary = shops.find((s) => s.is_primary) || shops[0];
        if (!primary?.id) {
          throw new Error("No shop found for this account");
        }
        setShopId(primary.id);
        setIsOwner(primary.role === "Owner");
        setUserId(
          data.mechanic_id ||
            data.user_id ||
            primary.mechanic_id ||
            primary.user_id ||
            null,
        );
      } catch (err) {
        console.error("CalendarPage shop load error:", err);
        setError(err.message || "Failed to load shop context");
      } finally {
        setLoading(false);
      }
    }
    loadPrimaryShop();
  }, []);

  return (
    <>
      <Header />
      <Box sx={{ minHeight: "100vh", bgcolor: "#f7f9fc", py: 4, px: 2 }}>
        <Box sx={{ maxWidth: 1200, mx: "auto" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              Calendar
            </Typography>
            <Button component={RouterLink} to="/mechanic-dashboard" variant="outlined">
              Back to Dashboard
            </Button>
          </Box>

          {loading && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
              <CircularProgress />
            </Box>
          )}

          {!loading && error && (
            <Typography color="error">{error}</Typography>
          )}

          {!loading && !error && shopId && (
            <MechanicsCalendar shopId={shopId} userId={userId} isOwner={isOwner} />
          )}
        </Box>
      </Box>
      <Footer />
    </>
  );
}
